import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { HeaderComponent } from './shared/header/header.component';
import {
  TranslateDirective,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { FooterComponent } from './shared/footer/footer.component';
import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  host: { id: 'app-root-main' },
})
export class AppComponent implements OnInit {
  title = 'qootk-website';
  private isBrowser: boolean;

  constructor(
    private translate: TranslateService,
    private viewportScroller: ViewportScroller,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.translate.addLangs(['ar', 'en']);
    this.translate.setDefaultLang('en');

    // Set initial language
    let savedLang = 'en';

    if (this.isBrowser) {
      // Check URL parameters first (from SSR)
      const urlParams = new URLSearchParams(window.location.search);
      const langParam = urlParams.get('__lang');

      if (langParam && (langParam === 'ar' || langParam === 'en')) {
        // Use the language from URL parameter
        savedLang = langParam;
        // Store it for future visits
        localStorage.setItem('preferredLanguage', langParam);
        // Clean up URL by removing our parameter
        const cleanUrl = window.location.pathname +
                        window.location.search.replace(/[?&]__lang=\w+(&|$)/, '$1');
        window.history.replaceState({}, this.document.title, cleanUrl);
      } else {
        // Fallback to localStorage
        savedLang = localStorage.getItem('preferredLanguage') || 'en';
      }
    }

    this.translate.use(savedLang);
    this.setDocumentDirection(savedLang);

    // Subscribe to language changes
    this.translate.onLangChange.subscribe(event => {
      this.setDocumentDirection(event.lang);
      if (this.isBrowser) {
        localStorage.setItem('preferredLanguage', event.lang);
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
    });
  }

  scrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  private setDocumentDirection(lang: string) {
    this.document.documentElement.lang = lang;
    this.document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}
